"use client";

import { Translate } from "@/components/Translate";
import {
	AlertDialogActions,
	AlertDialogClose,
	AlertDialogContent,
	AlertDialogRoot,
	AlertDialogTitle,
	AlertDialogViewport,
} from "@/components/ui/AlertDialog";
import { Button } from "@/components/ui/Button";
import { atom, useAtom, useSetAtom } from "jotai";
import React from "react";

const accountRemovedOpen = atom(false);

export const AccountRemovedPopup = () => {
	const [open, setOpen] = useAtom(accountRemovedOpen);

	return (
		<AlertDialogRoot
			open={open}
			onOpenChange={() => {
				setOpen(false);
			}}
		>
			<AlertDialogViewport backdropBlur>
				<AlertDialogContent>
					<AlertDialogTitle>
						<Translate>Your membership has been cancelled</Translate>
					</AlertDialogTitle>

					<p>
						<Translate>
							Thank you for being a member with us. We truly appreciate the time you've spent as
							part of our loyalty club.
						</Translate>
					</p>

					<AlertDialogActions justify="start">
						<AlertDialogClose asChild>
							<Button>Close</Button>
						</AlertDialogClose>
					</AlertDialogActions>
				</AlertDialogContent>
			</AlertDialogViewport>
		</AlertDialogRoot>
	);
};

export const useOpenAccountRemoved = () => {
	const setOpen = useSetAtom(accountRemovedOpen);
	return () => setOpen(true);
};
